function debounce<TFunc extends Function>(this: unknown, func: TFunc, timeout = 300) {
	let timer: NodeJS.Timeout | undefined;
	return (...args: unknown[]) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}

export {
	debounce,
};
